import React from 'react';
import { DeleteConfirmationModalProps } from './types';
import { styles } from './styles';
import { Modal, Button } from '@v2/components';

const DEFAULT_TITLE = 'Delete confirmation';
const DEFAULT_MESSAGE = 'Are you sure you want to delete this item?';

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting = false,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  cancelLabel = 'Cancel',
  deleteLabel = 'Delete',
}) => {
  const handleClose = () => {
    if (!isDeleting) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      size="sm"
      footer={
        <div className={styles.footerActions}>
          <Button variant="outline" onClick={handleClose} disabled={isDeleting}>
            {cancelLabel}
          </Button>
          <Button
            variant="danger"
            onClick={() => void onConfirm()}
            disabled={isDeleting}
            isLoading={isDeleting}>
            {deleteLabel}
          </Button>
        </div>
      }>
      <p className={styles.message}>{message}</p>
    </Modal>
  );
};

export default DeleteConfirmationModal;
